import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'

const STORAGE_KEY = 'ndapp:networkMode'

const readStoredMode = (): TWalletNetwork => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'testnet'
      ? 'testnet'
      : 'mainnet'
  } catch {
    return 'mainnet'
  }
}

let mode: TWalletNetwork =
  typeof window === 'undefined' ? 'mainnet' : readStoredMode()

export const networkMode = (): TWalletNetwork => mode

export const setNetworkMode = (network: TWalletNetwork) => {
  mode = network

  try {
    window.localStorage.setItem(STORAGE_KEY, network)
  } catch {
    // Nothing to do: the choice lasts for this page only.
  }
}

/**
 * The N3 network everything runs on — site and CMS alike. The pick in the network
 * bar is the only thing that decides it: give anything else a vote (the CMS used
 * to own the network here) and it wins whenever the two disagree, which is a
 * Mainnet button that changes nothing.
 */
export const currentN3Network = (): string =>
  mode === 'testnet' ? 'neo3/testnet' : 'neo3/mainnet'

export const siteNetwork = (): TWalletNetwork => mode

export const walletNetworksInUse = (): TWalletNetwork[] => [siteNetwork()]
